require("../../sass/core.sass");

import {
    Router,
    Route,
    IndexRoute,
    IndexRedirect,
    hashHistory
} from "react-router";
let Provider = require("react-redux").Provider;
import React from "react";

import NounProjectPlugin from "../components/nounproject-plugin";
import NounPluginWrapper from "../components/nounproject-plugin-wrapper";

import store from "../stores/reduxStore";

import NounProjectPluginAuth from "./nounproject-plugin-auth";
import PluginBilling from "./plugin-billing";
import PluginConfirmation from "../components/plugin-confirmation";
import PluginMenu from "../components/plugin-menu";
import PluginAbout from "../components/plugin-about";
import PluginFeedback from "../components/plugin-feedback";
import PluginFacebook from "../components/plugin-facebook";

class Plugin extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <div style={{ width: "100%", height: "100%" }}>
                    <style>{`
                        html{
                            overflow: hidden;
                            height: 100%;
                            -ms-content-zooming: none;
                        }
                        body{
                            overflow: auto;
                            height: 100%;
                            -ms-content-zooming: none;
                        }
                        #plugin-body,
                        #page-wrapper,
                        #main-content,
                        #search-icons,
                        .react-es6-component{
                            height: 100%;
                            padding: 0;
                        }
                    `}</style>
                    <Router history={hashHistory}>
                        <Route path="/" component={NounPluginWrapper}>
                            <IndexRedirect to="/search" />
                        </Route>
                        <Route path="search" component={NounPluginWrapper}>
                            <IndexRoute component={NounProjectPlugin} />
                        </Route>
                        <Route
                            path="search/(:slug)"
                            component={NounPluginWrapper}
                        >
                            <IndexRoute component={NounProjectPlugin} />
                        </Route>
                        <Route path="about" component={PluginAbout} />
                        <Route path="menu" component={PluginMenu} />
                        <Route path="login" component={NounProjectPluginAuth} />
                        <Route path="feedback" component={PluginFeedback} />
                        <Route path="facebook" component={PluginFacebook} />
                        <Route
                            path="signup"
                            component={NounProjectPluginAuth}
                        />
                        <Route path="billing" component={PluginBilling} />
                        <Route
                            path="confirmation"
                            component={PluginConfirmation}
                        />
                    </Router>
                </div>
            </Provider>
        );
    }
}

module.exports = Plugin;
